"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainRequest = void 0;
var MainRequest = /** @class */ (function () {
    function MainRequest() {
    }
    return MainRequest;
}());
exports.MainRequest = MainRequest;
;
//# sourceMappingURL=main.request.js.map